<app-header bannerImage="yaraFlags.webp"></app-header>
<div markdown [src]="sourcePath">
  
</div>
